import { render, staticRenderFns } from "./ShippingCollectiveRegisterList.html?vue&type=template&id=0117467e&scoped=true&external"
import script from "./ShippingCollectiveRegisterList.ts?vue&type=script&lang=ts&external"
export * from "./ShippingCollectiveRegisterList.ts?vue&type=script&lang=ts&external"
import style0 from "./ShippingCollectiveRegisterList.css?vue&type=style&index=0&id=0117467e&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0117467e",
  null
  
)

export default component.exports